import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoMigrationsGetRes } from "./abst/DtoMigrationsGetRes";

export class DtoMigrationsGetResImple extends DtoMigrationsGetRes {
  public pager = new DtoApiPager();
}
